<!-- Spacer -->
<div
    class="cb-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
